/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SettingTabletView from '../../view/pages/room/SettingTabletView'
import HouseManualsStore from '../../store/room/HouseManualsStore'
import HouseManualStore from '../../store/room/HouseManualStore'
import RoomStore from '../../store/room/RoomStore'
import TabletsStore from '../../store/room/TabletsStore'
import TabletsAction from '../../action/tablet'
import RoomAction from '../../action/room'
import SettingTabletStore from '../../store/room/SettingTabletStore'
import HotelManualAction from '../../action/hotel_manual'

class SettingTabletContainer extends Component {
  static getStores() {
    return [SettingTabletStore, RoomStore, HouseManualsStore, HouseManualStore, TabletsStore]
  }

  static calculateState(prevState, props) {
    return {
      settingTablet: SettingTabletStore.getState(),
      room: RoomStore.getState(),
      manuals: HouseManualsStore.getState(),
      selectedManual: HouseManualStore.getState(),
      tablets: TabletsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const id = this.state.match.params.id

    // TODO id がない場合はエラー
    if (id) {
      const showManualDialog = Object.prototype.hasOwnProperty.call(this.state, 'showManualDialog') ? this.state.showManualDialog : false

      RoomAction.fetchOne(id)

      if (!showManualDialog) {
        // ハウスマニュアルのダイアログ表示の場合はデータを取得しない
        HotelManualAction.fetchAll(id)
        TabletsAction.fetchAll(id)
      }

      // ハウスマニュアル編集
      const manual_id = this.state.match.params.mid
      if (manual_id) {
        HotelManualAction.fetchOne(manual_id)
      }
    }
  }

  render() {
    return SettingTabletView(this.state)
  }
}

export default withRouter(Container.create(SettingTabletContainer, { withProps: true }))
